import { useEffect } from "react";

export const useDidMount = (callback) => {
  useEffect(() => {
    if (typeof callback === "function") {
      callback();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};
